import { cva, type VariantProps } from 'class-variance-authority';

/**
 * DegreeCardDetailed CVA variants.
 * Border-radius 20px (--border-radius/lg). The card sizes to its container /
 * grid cell: `w-full` + `min-w-0` (no min-width floor) so it fluidly fills a
 * multi-column grid without overflowing or overlapping neighbors, and `h-full`
 * so siblings in a stretched row render at equal height. The column flex
 * layout and `CardFooter`'s `mt-auto` pin the footer to the bottom.
 * `detailListItemsPosition="bottom"` grows the body, cancels that margin,
 * and gives the detail rows `mt-auto` so they sit just above the footer.
 */
export const degreeCardDetailedVariants = cva(
  'flex h-full min-w-0 flex-col w-full rounded-lg overflow-hidden',
  {
    variants: {
      border: {
        none: '',
        stroke: 'border border-neutral-200',
        shadow: 'border border-neutral-200 shadow-sm',
      },
    },
    defaultVariants: {
      // Saved listings omit `border` and were outlined before this control
      // existed. New editor drops persist the catalog default of `none`.
      border: 'stroke',
    },
  },
);

export type DegreeCardDetailedVariantProps = VariantProps<
  typeof degreeCardDetailedVariants
>;
